/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "structure";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GeometryType {
}

export enum GeometryType_Enum {
  UNKNOWN = 0,
  BOX = 1,
  CYLINDER = 2,
  POINT = 3,
  UNRECOGNIZED = -1,
}

export function geometryType_EnumFromJSON(object: any): GeometryType_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return GeometryType_Enum.UNKNOWN;
    case 1:
    case "BOX":
      return GeometryType_Enum.BOX;
    case 2:
    case "CYLINDER":
      return GeometryType_Enum.CYLINDER;
    case 3:
    case "POINT":
      return GeometryType_Enum.POINT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GeometryType_Enum.UNRECOGNIZED;
  }
}

export function geometryType_EnumToJSON(object: GeometryType_Enum): string {
  switch (object) {
    case GeometryType_Enum.UNKNOWN:
      return "UNKNOWN";
    case GeometryType_Enum.BOX:
      return "BOX";
    case GeometryType_Enum.CYLINDER:
      return "CYLINDER";
    case GeometryType_Enum.POINT:
      return "POINT";
    case GeometryType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseGeometryType(): GeometryType {
  return {};
}

export const GeometryType = {
  encode(_: GeometryType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GeometryType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometryType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GeometryType {
    return {};
  },

  toJSON(_: GeometryType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GeometryType>, I>>(base?: I): GeometryType {
    return GeometryType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeometryType>, I>>(_: I): GeometryType {
    const message = createBaseGeometryType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
